export default "__VITE_ASSET__BhPR2UAc__"